import { PERMISSIONS } from '@helios/authz';
import { useScopedOperationalMutation, useScopedOperationalQuery } from '@/hooks/useScopedOperationalQuery';
import { seedDataApi } from './seedData.api';
import type { SeedExpansionInput } from './seedData.api';
export function useSeedDataCommandCenter() {
  return useScopedOperationalQuery('seed-data', PERMISSIONS.PLATFORM_ADMIN, seedDataApi.getDashboard, 60_000);
}
export function useExpandSeedData() {
  return useScopedOperationalMutation('seed-data', PERMISSIONS.PLATFORM_ADMIN, (input: SeedExpansionInput, options) => seedDataApi.expand(input, options));
}
